import type { EntityConfigDefinition, DisplayColumnConfig } from '../../types/entityConfig'

const config: EntityConfigDefinition = {
  name: 'APPLICATION_STEP_STATUS',
  idField: 'APPLICATION_STEP_STATUS_ID',
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['APPLICATION_STEP_STATUS_ID'],
  
  // APPLICATION_STEP_STATUS shows list of all statuses, not optimized for single status details
  useOptimizedQuery: false,
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['APPLICATION_ID'],
    stringMatchFields: ['APPLICATION_ID'],
    stringMatchThreshold: 0.50,
    displayFields: ['APPLICATION_STEP_STATUS_ID', 'APPLICATION_ID', 'APPLICATION_EXEC_ID', 'APPLICATION_PRODUCT_ID', 'STEP_TYPE_ID', 'COMPLETE_FLAG', 'SEQUENCE_NBR', 'IDX_JSON_PATH', 'RESPONSE_TEXT', 'OUTPUT_JSON', 'CREATED_DATE'],
    resolveLookupsForBothEnvironments: true
  },
  
  // Foreign key lookups
  foreignKeys: {
    "APPLICATION_ID": {
      "table": "APPLICATION",
      "valueField": "APPLICATION_ID",
      "displayField": "APPLICATION_NAME"
    },
    "APPLICATION_EXEC_ID": {
      "table": "APPLICATION_EXECS",
      "valueField": "APPLICATION_EXEC_ID",
      "displayField": "APPLICATION_EXEC_NAME"
    },
    "APPLICATION_PRODUCT_ID": {
      "table": "APPLICATION_PRODUCT",
      "valueField": "APPLICATION_PRODUCT_ID",
      "displayField": "APPLICATION_PRODUCT_NAME"
    },
    "STEP_TYPE_ID": {
      "table": "STEP_TYPE",
      "valueField": "STEP_TYPE_ID",
      "displayField": "STEP_TYPE_NAME"
    }
  },
  
  // Field lookups for display enhancement
  fieldLookups: {
    "APPLICATION_ID": {
      "lookupTable": "APPLICATION",
      "foreignKey": "APPLICATION_ID",
      "displayField": "APPLICATION_NAME",
      "displayFormat": "{APPLICATION_ID}: {APPLICATION_NAME}"
    },
    "APPLICATION_EXEC_ID": {
      "lookupTable": "APPLICATION_EXECS",
      "foreignKey": "APPLICATION_EXEC_ID",
      "displayField": "APPLICATION_EXEC_NAME",
      "displayFormat": "{APPLICATION_EXEC_ID}: {APPLICATION_EXEC_NAME}"
    },
    "APPLICATION_PRODUCT_ID": {
      "lookupTable": "APPLICATION_PRODUCT",
      "foreignKey": "APPLICATION_PRODUCT_ID",
      "displayField": "APPLICATION_PRODUCT_NAME",
      "displayFormat": "{APPLICATION_PRODUCT_ID}: {APPLICATION_PRODUCT_NAME}"
    },
    "STEP_TYPE_ID": {
      "lookupTable": "STEP_TYPE",
      "foreignKey": "STEP_TYPE_ID",
      "displayField": "STEP_TYPE_NAME",
      "displayFormat": "{STEP_TYPE_ID}: {STEP_TYPE_NAME}"
    }
  },
  
  // Display columns with foreign key lookups
  displayColumns: [
    {
      field: 'APPLICATION_ID',
      lookup: {
        table: 'APPLICATION',
        foreignKey: 'APPLICATION_ID',
        displayField: 'APPLICATION_NAME'
      }
    },
    {
      field: 'APPLICATION_EXEC_ID',
      lookup: {
        table: 'APPLICATION_EXECS',
        foreignKey: 'APPLICATION_EXEC_ID',
        displayField: 'APPLICATION_EXEC_NAME'
      }
    },
    {
      field: 'APPLICATION_PRODUCT_ID',
      lookup: {
        table: 'APPLICATION_PRODUCT',
        foreignKey: 'APPLICATION_PRODUCT_ID',
        displayField: 'APPLICATION_PRODUCT_NAME'
      }
    },
    {
      field: 'STEP_TYPE_ID',
      lookup: {
        table: 'STEP_TYPE',
        foreignKey: 'STEP_TYPE_ID',
        displayField: 'STEP_TYPE_NAME'
      }
    }
  ] as DisplayColumnConfig[],

  // Fields configuration
  fields: [
    "APPLICATION_STEP_STATUS_ID",
    "APPLICATION_ID",
    "APPLICATION_EXEC_ID",
    "APPLICATION_PRODUCT_ID",
    "STEP_TYPE_ID",
    "COMPLETE_FLAG",
    "SEQUENCE_NBR",
    "IDX_JSON_PATH",
    "RESPONSE_TEXT",
    "OUTPUT_JSON",
    "CREATED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      "name": "APPLICATION_ID",
      "type": "select",
      "required": true,
      "disabled": false,
      "options": []
    },
    {
      "name": "APPLICATION_EXEC_ID",
      "type": "select",
      "required": false,
      "disabled": false,
      "options": []
    },
    {
      "name": "APPLICATION_PRODUCT_ID",
      "type": "select",
      "required": false,
      "disabled": false,
      "options": []
    },
    {
      "name": "STEP_TYPE_ID",
      "type": "select",
      "required": true,
      "disabled": false,
      "options": []
    },
    {
      "name": "COMPLETE_FLAG",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "SEQUENCE_NBR",
      "type": "number",
      "required": true,
      "disabled": false
    },
    {
      "name": "IDX_JSON_PATH",
      "type": "text",
      "required": false,
      "disabled": false
    },
    {
      "name": "RESPONSE_TEXT",
      "type": "text",
      "required": false,
      "disabled": false
    },
    {
      "name": "OUTPUT_JSON",
      "type": "text",
      "required": false,
      "disabled": false
    },
    {
      "name": "CREATED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    }
  ]
}

export default config

